import React from 'react';
import { FormControl, FormControlLabel, FormGroup, Switch } from '@mui/material';

interface SwitchPastEventsProps {
  viewPastEvents: boolean;
  onChange: (value: boolean) => void;
}

export const SwitchPastEvents: React.FC<SwitchPastEventsProps> = ({
  viewPastEvents,
  onChange
}) => {
  return (
    <div className="event-grid-header-switch">
      <FormControl component="fieldset">
        <FormGroup aria-label="position" row>
          <FormControlLabel
            control={<Switch color="primary" checked={viewPastEvents} />}
            label="View past events"
            labelPlacement="start"
            onChange={(event, value) => onChange(value)}
          />
        </FormGroup>
      </FormControl>
    </div>
  );
}; 